// Iconos Material en Descripción.
$('.description-product__answer-container.materials p').each(function(){
    if($(this).text()== '24K Gold Plating' || $(this).text()== '24K Gold Plating' || $(this).text()== 'Fine Silver' || $(this).text()== '18K Gold Plated' || $(this).text()== 'High Polished Sterling Silver'){
        $(this).addClass('icon-description-gold');
    } else if ($(this).text()== 'Enamel') {
        $(this).addClass('icon-description-enamel');
    } else if ($(this).text()== 'Freshwater Pearl') {
        $(this).addClass('icon-description-freshwater-pearl');
    } else {
        $(this).addClass('icon-description-stones');
    };
});


document.addEventListener('rebuy.ready', function(event){  
  $( ".shop-the-look__section .rebuy-bundle .rebuy-product-block" ).each(function() {
    var $id = $(this).attr('class').split(' ')[2]; 
    var $image = ".rebuy-bundle__images ." + $id + " a.rebuy-bundle__image-item";
    $(this).prepend($($image));
  });

  if( $('.container-shop-the-look__section .rebuy-bundle__items').is(':empty') ) {
      $('.container-shop-the-look__section').hide();
  };
});
